'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { AnaliseValorMetrics } from '../types/analytics.types';
import { TrendingUp } from 'lucide-react';
interface FaixasValorChartProps {
  data: AnaliseValorMetrics;
}
export const FaixasValorChart: React.FC<FaixasValorChartProps> = t0 => {
  const $ = _c(27);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.faixasValor) {
    t1 = data.faixasValor.map(_temp);
    $[0] = data.faixasValor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const chartData = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-6"><h3 className="text-lg font-semibold text-neutral-900">Performance por Faixa de Valor</h3><p className="text-sm text-neutral-500">Relação entre valor da dívida e taxa de sucesso</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      top: 20,
      right: 30,
      left: 0,
      bottom: 5
    };
    t4 = <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
      fill: "#6b7280",
      fontSize: 11
    }} dy={10} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <YAxis yAxisId="left" axisLine={false} tickLine={false} tick={{
      fill: "#6b7280",
      fontSize: 12
    }} label={{
      value: "Taxa (%)",
      angle: -90,
      position: "insideLeft",
      fill: "#6b7280"
    }} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <YAxis yAxisId="right" orientation="right" axisLine={false} tickLine={false} tick={{
      fill: "#6b7280",
      fontSize: 12
    }} label={{
      value: "Volume",
      angle: 90,
      position: "insideRight",
      fill: "#6b7280"
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Tooltip contentStyle={{
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)"
    }} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Legend wrapperStyle={{
      paddingTop: "20px"
    }} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Bar yAxisId="right" dataKey="Volume (Qtd)" fill="#f3f4f6" radius={[4, 4, 0, 0]} barSize={40} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Line yAxisId="left" type="monotone" dataKey="Taxa de Sucesso (%)" stroke="#2a1b63" strokeWidth={3} dot={{
      r: 4,
      fill: "#2a1b63",
      strokeWidth: 2,
      stroke: "#fff"
    }} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Line yAxisId="left" type="monotone" dataKey="Taxa de Resposta (%)" stroke="#8b5cf6" strokeWidth={2} dot={{
      r: 3,
      fill: "#8b5cf6",
      strokeWidth: 2,
      stroke: "#fff"
    }} strokeDasharray="5 5" />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== chartData) {
    t13 = <div className="h-[300px] w-full"><ResponsiveContainer width="100%" height="100%"><ComposedChart data={chartData} margin={t3}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</ComposedChart></ResponsiveContainer></div>;
    $[13] = chartData;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="bg-chart-primary/10 text-chart-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><TrendingUp className="h-5 w-5" /></div>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== data.faixaMaisEfetiva.faixa) {
    t15 = <h4 className="text-chart-primary font-medium">Faixa Mais Efetiva: {data.faixaMaisEfetiva.faixa}</h4>;
    $[16] = data.faixaMaisEfetiva.faixa;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== data.faixaMaisEfetiva.motivoPrincipal || $[19] !== data.faixaMaisEfetiva.taxaSucesso) {
    t16 = <p className="text-sm text-neutral-600">{data.faixaMaisEfetiva.taxaSucesso}% de sucesso. {data.faixaMaisEfetiva.motivoPrincipal}</p>;
    $[18] = data.faixaMaisEfetiva.motivoPrincipal;
    $[19] = data.faixaMaisEfetiva.taxaSucesso;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t15 || $[22] !== t16) {
    t17 = <div className="border-chart-primary/10 bg-chart-primary/5 mt-6 flex flex-col gap-4 rounded-lg border p-4 sm:flex-row sm:items-center">{t14}<div>{t15}{t16}</div></div>;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t13 || $[25] !== t17) {
    t18 = <div className="rounded-xl border border-neutral-100 bg-white p-6 shadow-sm">{t2}{t13}{t17}</div>;
    $[24] = t13;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  return t18;
};
function _temp(item) {
  return {
    name: item.label,
    "Taxa de Sucesso (%)": item.taxaSucesso,
    "Volume (Qtd)": item.totalCasos,
    "Taxa de Resposta (%)": item.taxaResposta
  };
}